import { Button, PlusIcon } from "@monsterindia/global-ui-components";
import React, { useEffect, useState } from "react";

import { API_ENDPOINT } from "../../../../constants/appConstant";
import { useNetwork } from "../../../../hooks/useNetwork";
import { CheckboxOptionType, MasterDataType } from "../../../../types";
import { ErrorText } from "../ErrorText";
import LanguageCard from "./Language";
import { LanguageCardContainerProps } from "./Language.types";

const LanguageCardContainer = ({
  languageDataArray,
  control,
  setValue,
  errors,
  clearErrors,
  addAnotherLanguageDataHandler,
  deleteLanguageDataHandler,
}: LanguageCardContainerProps) => {
  const [languageProficiencyData, setLanguageProficiencyData] = useState<
    CheckboxOptionType[] | null
  >(null);

  const { fetchData: fetchAPI } = useNetwork();

  const languageProficiency = async () => {
    const res = await fetchAPI(
      `${API_ENDPOINT().seekerProfile.masterDataMiddleware}?type=LANGUAGE_PROFICIENCY&name=`,
      "GET",
    );

    const masterData = (res.data as any)?.data as MasterDataType[];

    const updatedData =
      masterData && masterData.length > 0
        ? masterData.map((data) => {
            return {
              value: data.name,
              id: data.uuid,
              text: data.name,
            };
          })
        : [];

    setLanguageProficiencyData(updatedData);
  };

  useEffect(() => {
    languageProficiency();
  }, []);

  return (
    <div className="l1-flex l1-flex-col l1-gap-4 l1-items-start l1-w-full l1-bg-surface-background l1-p-4 l1-rounded-lg l1-border l1-border-border-subtle">
      <div className="l1-flex l1-flex-col l1-gap-1 l1-items-start l1-w-full">
        <p className="l1-text-content-primary l1-font-bold l1-text-base">
          Languages <span className="l1-text-state-surface-error-bold">*</span>
        </p>
        <p className="l1-text-content-primary l1-font-normal l1-text-xs">
          Add languages you know and get noticed by recruiters.
        </p>
      </div>

      {languageDataArray &&
        languageDataArray.length > 0 &&
        languageDataArray.map((data, index) => (
          <LanguageCard
            key={index}
            index={index}
            totalLength={languageDataArray.length}
            control={control}
            clearErrors={clearErrors}
            setValue={setValue}
            errors={errors}
            languageProficiencyData={languageProficiencyData}
            onLanguageDeleteBtnClickHandler={(i) => {
              deleteLanguageDataHandler(i);
            }}
          />
        ))}

      <Button
        type="button"
        modifier="tertiary"
        label="Add language"
        size="sm"
        className="language-add-button"
        onClick={() => {
          addAnotherLanguageDataHandler();
        }}
        leftIcon={<PlusIcon className="l1-h-4 l1-w-4 l1-fill-brand-primary" />}
      />
    </div>
  );
};

export default LanguageCardContainer;
